export const getDiff = (values, columns) => {
  const result =
    Math.round(values[columns[0].id]) - Math.round(values[columns[1].id])

  return isNaN(result) ? 0 : Math.round(result)
}
